module.exports = __webpack_public_path__ + "ch.f0617e6d.svg";